<template>
  <!--嘉宾管理-->
  <div class="content guestManagement">
    <div class="layui-fluid">
      <div class="layui-row">
        <div class="layui-col-md12">
          <!--面包屑-->
          <div class="layui-row">
            <div class="layui-col-md12">
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '' }">用户管理</el-breadcrumb-item>
                <el-breadcrumb-item>嘉宾管理</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>
          <div
            class="layui-row"
            style="margin-top: 20px;"
          >
            <div class="layui-col-md12">
              <form
                class="layui-form"
                action
              >
                <!-- <div class="layui-form-item">
                  <div class="layui-inline">
                    <label class="layui-form-label">选择会议:</label>
                    <div class="layui-input-block">
                      <select name="interest" lay-filter="aihao">
                        <option value></option>
                        <option value="0">写作</option>
                      </select>
                    </div>
                  </div>
                  <div class="layui-inline">
                    <label class="layui-form-label">嘉宾名称:</label>
                    <div class="layui-input-block">
                      <input
                        type="text"
                        name="title"
                        lay-verify="title"
                        autocomplete="off"
                        placeholder="请输入"
                        class="layui-input"
                        id="put"
                      />
                    </div>
                  </div>
                  <div class="layui-inline right_btn">
                    <button class="layui-btn" @click="check">搜索</button>
                  </div>
                </div>-->
              </form>
            </div>
          </div>
          <div class="layui-row">
            <div class="layui-col-md2">         
              <el-button
                id="handleAuthorLibrary"
                @click="autor"
                type="primary"
              >先晓作者库</el-button>
            </div>
            <div class="layui-col-md2">
              <el-button
                @click="newGuest"
                type="primary"
              >新建嘉宾</el-button>
            </div>
          </div>
          <div class="layui-row">
            <div class="layui-col-md12">
              <table
                id="test"
                lay-filter="test"
              ></table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="dialogFormVisibleFour"
      :modal-append-to-body="false"
    >
      <div class="layui-form-item" style="text-align: center">
        <div class="layui-input-inline">
          <input type="text" name="title" required lay-verify="required" v-model="searchName" placeholder="请输入搜索姓名" autocomplete="off" class="layui-input">
        </div>
        <div class=" layui-input-inline" style="text-align:left;">
          <button type="button" class="layui-btn layui-btn-normal" @click="searchAuthor">搜索</button>
        </div>

      </div>
      <table
        class="layui-hide"
        id="test2"
      ></table>
      <div id="author_pagebox"></div>
      <div
        class="layui-form-item"
        style="text-align: center"
      >
        <button
          type="button"
          class="layui-btn"
          id="handleDetermine"
          @click="sub"
        >确定</button>
        <button
          type="reset"
          class="layui-btn layui-btn-primary"
          @click="dialogFormVisibleFour = false"
        >取消</button>
      </div>
    </el-dialog>
    <el-dialog
      title="嘉宾详情"
      :visible.sync="jiabin"
      :modal-append-to-body="false"
      center
    >
      <el-dialog
        width="30%"
        title="内层 Dialog"
        append-to-body
      ></el-dialog>
      <el-row>
        <el-col :span="3">
          <div
            class="grid-content bg-purple"
            style=" text-align: center;"
          >
            <b>头像：</b>
          </div>
        </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple-light">
            <el-avatar
              shape="square"
              :size="100"
              fit="contain"
              :src="jiabin_message.head_img"
            ></el-avatar>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div
            class="grid-content bg-purple"
            style=" text-align: center;"
          >
            <b>嘉宾姓名:</b>
          </div>
        </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple-light">{{jiabin_message.name}}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div
            class="grid-content bg-purple"
            style=" text-align: center;"
          >
            <b>ssapid：</b>
          </div>
        </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple-light">{{jiabin_message.ssapid}}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div
            class="grid-content bg-purple"
            style=" text-align: center;"
          >
            <b>简介：</b>
          </div>
        </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple-light">{{jiabin_message.description}}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <div
            class="grid-content bg-purple"
            style=" text-align: center;"
          >
            <b>研究领域：</b>
          </div>
        </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple-light">{{jiabin_message.domain}}</div>
        </el-col>
      </el-row>
      <div style="width:100%;display:flex;justify-content: center">
        <el-button
          @click="jiabin = false"
          type="warning"
        >关闭</el-button>
      </div>
    </el-dialog>
    <script
      type="text/html"
      id="barDemo"
    >
    <a
      class="layui-btn layui-btn-xs"
      lay-event="edit"
      style="color: #FFFFFF;"
    >查看详情</a>
    <a
      class="layui-btn layui-btn-xs"
      lay-event="edit3"
      style="color: #FFFFFF;"
    >编辑</a>
    <a
      class="layui-btn layui-btn-danger layui-btn-xs"
      lay-event="edit2"
      style="color: #FFFFFF;"
    >删除</a>
    </script>
  </div>
</template>

<script>
export default {
  name: "GuestManagement",
  data () {
    return {
      msg: "",
      title: "",
      dialogFormVisibleFour: false,
      jiabin: false,
      jiabin_message: {},
      searchName:'',//搜索人员名称
      page:1,//作者库
      pagesize:10,//每页条数作者库
    };
  },
  components: {},
  methods: {
    //新增嘉宾
    newGuest () {
      this.$router.push({ path: "/Guest/NewGuest" });
    },
    /* 搜索 */
    check () {
      var _this = this;
      layui.use(["jquery", "element", "form", "table"], function () {
        var $ = layui.jquery;
        var element = layui.element;
        var form = layui.form;
        var table = layui.table;
        var name = $("#put").val();
        let url = "/ac1/conference/guest/guestList";
        let params = {
          name: name,
        };
        _this
          .$get(url, params)
          .then((res) => {
            console.log(res);
            if (res.code == "1")
            {
              table.render({
                elem: "#test",
                data: res.posts.data,
                response: {
                  statusName: "code", //规定数据状态的字段名称，默认：code
                  statusCode: 1, //规定成功的状态码，默认：0
                  msgName: "hint", //规定状态信息的字段名称，默认：msg
                  countName: "total", //规定数据总数的字段名称，默认：count
                  dataName: "posts", //规定数据列表的字段名称，默认：data
                },
                cols: [
                  [
                    { field: "id", title: "ID" },
                    {
                      field: "head_img",
                      title: "嘉宾头像",
                      templet: '<div><img src="{{d.head_img}}"></div>',
                      width: 80,
                    },
                    { field: "name", title: "姓名" },
                    { field: "ssapid", title: "ssapid" },
                    { field: "description", title: "简介" },
                    { field: "domain", title: "研究领域" },
                    {
                      field: "is_author",
                      title: "是否是先晓作者",
                      templet: function (res) {
                        if (res.is_author == 1)
                        {
                          return "是";
                        } else if (res.is_author == 0)
                        {
                          return "否";
                        }
                      },
                    },
                    {
                      field: "status",
                      title: "状态",
                      templet: function (res) {
                        if (res.status == 1)
                        {
                          return "正常";
                        } else if (res.status == 0)
                        {
                          return "禁用";
                        }
                      },
                    },
                    {
                      title: "操作",
                      width: 200,
                      fixed: "right",
                      toolbar: "#barDemo",
                    },
                  ],
                ],
                page: true,
                // done: function (res, curr, count) {
                //   console.log(res);
                //   var that = this.elem.next();
                //   res.posts.forEach(function (item, index) {
                //     if (item.is_author == "1") {
                //       var tr = that.find(
                //         ".layui-table-box tbody tr[data-index='" + index + "']"
                //       );
                //       tr.find("td").eq(8).find("a").eq(1).hide();
                //       console.log(tr.find("td").eq(8));
                //     }
                //   });
                // },
              });
            } else
            {
              console.log(res.msg);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
    /* 作者库 */
    autor () {
      var _this = this;
      layui.use(["jquery", "element", "form", "table","laypage"], function () {
        var $ = layui.jquery;
        var element = layui.element;
        var form = layui.form;
        var table = layui.table;
        var laypage = layui.laypage;
        //先晓作者库弹窗
        _this.dialogFormVisibleFour = true;
        _this.title = "选择作者";
        let url = "/ac1/conference/authorLib";
        _this.$get(url,{name:_this.searchName,page:_this.page,pagesize:_this.pagesize}).then((res) => {
          let tableAry = [];
          for (let i = 0; i < res.posts.hits.length; i++)
          {
            tableAry.push(res.posts.hits[i]._source);
          }
          console.log("作者库", res);

          if (res.code == "1")
          {
           if(_this.page == 1){
             laypage.render({
               elem: 'author_pagebox' //注意，这里的 test1 是 ID，不用加 # 号
               ,count: res.posts.total.value //数据总数，从服务端得到
               ,limit:_this.pagesize
               ,jump: function(obj, first){
                // console.log(obj.curr); //得到当前页，以便向服务端请求对应页的数据。
               //  console.log(obj.limit); //得到每页显示的条数
                 //首次不执行
                 if(!first){
                   //do something
                   _this.page = obj.curr;
                   _this.autor();
                 }
               }
             });
           }
            table.render({
              elem: "#test2",
              data: tableAry,
              text: {
                none: "暂无相关数据", //默认：无数据。
              },
              response: {
                statusName: "code", //规定数据状态的字段名称，默认：code
                statusCode: 1, //规定成功的状态码，默认：0
                msgName: "hint", //规定状态信息的字段名称，默认：msg
                countName: "total", //规定数据总数的字段名称，默认：count
                dataName: "posts", //规定数据列表的字段名称，默认：data
              },
              cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
              cols: [
                [
                  { type: "checkbox" },
                  { field: "id", title: "ID" },
                  {
                    field: "head_img",
                    title: "嘉宾头像",
                    templet: '<div><img src="{{d.head_img}}"></div>',
                  },
                  { field: "name", title: "姓名" },
                  { field: "ssap_id", title: "ssapid" },
                  { field: "abstracts", title: "简介" },
                  { field: "domain", title: "研究领域" },
                ],
              ],
              page: false,
            });
          } else
          {
            console.log(res.msg);
          }
        });
      });
    },
    searchAuthor(){
      this.page = 1;
      this.autor();
    },
    /* 提交 */
    sub () {
      var _this = this;
      layui.use(["jquery", "element", "form", "table"], function () {
        var $ = layui.jquery;
        var element = layui.element;
        var form = layui.form;
        var table = layui.table;
        /*选中的数据*/
        let checkStatus = layui.table.checkStatus("test2").data;
        let url = "/ac1/guest/addMore";
        let params = [];
        for (let i = 0; i < checkStatus.length; i++)
        {
          var k = checkStatus[i];
          let objs = {
            name: k.name,
            company: k.company,
            tel: k.tel,
            domain: k.domain,
            description: k.abstracts,
            head_img: k.head_img,
            ssapid: k.ssap_id,
            author_id:k.id
          };
          params.push(objs);
        }
        _this.$post(url, params).then((res) => {
          if (res.code == "1")
          {
            _this.$message({
              message: '保存成功',
              type: 'success',
              duration: 1000
            });
            _this.dialogFormVisibleFour = false;
            let url = "/ac1/conference/guest/guestList";
            _this
              .$get(url)
              .then((res) => {
                if (res.code == "1")
                {
                  guestTable = table.render({
                    elem: "#test",
                    data: res.posts.data,
                    response: {
                      statusName: "code", //规定数据状态的字段名称，默认：code
                      statusCode: 1, //规定成功的状态码，默认：0
                      msgName: "hint", //规定状态信息的字段名称，默认：msg
                      countName: "total", //规定数据总数的字段名称，默认：count
                      dataName: "posts", //规定数据列表的字段名称，默认：data
                    },
                    cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
                    cols: [
                      [
                        { type: "checkbox" },
                        { field: "id", title: "ID" },
                        {
                          field: "head_img",
                          title: "嘉宾头像",
                          templet: '<div><img src="{{d.head_img}}"></div>',
                          width: 80,
                        },
                        { field: "name", title: "姓名" },
                        { field: "ssapid", title: "ssapid" },
                        { field: "description", title: "简介" },
                        ,
                        {
                          field: "experience",
                          title: "研究领域",
                          width: 120,
                        },
                        {
                          field: "is_author",
                          title: "是否是先晓作者",
                          templet: function (res) {
                            if (res.is_author == 1)
                            {
                              return "是";
                            } else if (res.is_author == 0)
                            {
                              return "否";
                            }
                          },
                        },
                        {
                          field: "status",
                          title: "状态",
                          templet: function (res) {
                            if (res.status == 1)
                            {
                              return "正常";
                            } else if (res.status == 0)
                            {
                              return "禁用";
                            }
                          },
                        },
                        {
                          title: "操作",
                          width: 200,
                          fixed: "right",
                          toolbar: "#barDemo",
                        },
                      ],
                    ],
                    page: true,
                    // done: function (res, curr, count) {
                    //   console.log(res);
                    //   var that = this.elem.next();
                    //   res.posts.forEach(function (item, index) {
                    //     if (item.is_author == "1") {
                    //       var tr = that.find(
                    //         ".layui-table-box tbody tr[data-index='" +
                    //           index +
                    //           "']"
                    //       );
                    //       tr.find("td").eq(8).find("a").eq(1).hide();
                    //       console.log(tr.find("td").eq(8));
                    //     }
                    //   });
                    // },
                  });
                } else
                {
                  console.log(res.msg);
                }
              })
              .catch((error) => {
                console.log(error);
              });
          } else
          {
            console.log(res.msg);
          }
        });
      });
    },
    /* 监听详情，删除 */
    xiang () {
      let _this = this;
      layui.use(["jquery", "element", "table"], function () {
        var $ = layui.jquery;
        var element = layui.element;
        var table = layui.table;
        /* 监听查看详情*/
        table.on("tool(test)", function (obj) {
          var data = obj.data;
          console.log(obj);
          if (obj.event === "edit")
          {
            /* 查看详情 */
            _this.jiabin = true;
            _this.jiabin_message = data;
          } else if (obj.event === "edit2")
          {
            layer.confirm("确定删除此行么", function (index) {
              let url = "/ac1/conference/guestModifyStatus";
              var params = {
                id: data.id,
                status: 0,
              };
              _this.$post(url, params).then((res) => {
                if (res.code == 1)
                {
                  obj.del(); //删除对应行（tr）的DOM结构，并更新缓存
                  layer.close(index);
                  _this.$message({
                    message: '删除成功',
                    type: 'success',
                    duration: 1000
                  });
                  let url = "/ac1/conference/guest/guestList";
                  _this
                    .$get(url)
                    .then((res) => {
                      console.log(res);
                      if (res.code == "1")
                      {
                        guestTable =  table.render({
                          elem: "#test",
                          data: res.posts.data,
                          response: {
                            statusName: "code", //规定数据状态的字段名称，默认：code
                            statusCode: 1, //规定成功的状态码，默认：0
                            msgName: "hint", //规定状态信息的字段名称，默认：msg
                            countName: "total", //规定数据总数的字段名称，默认：count
                            dataName: "posts", //规定数据列表的字段名称，默认：data
                          },
                          cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
                          cols: [
                            [
                              { type: "checkbox" },
                              { field: "id", title: "ID" },
                              {
                                field: "head_img",
                                title: "嘉宾头像",
                                templet: '<div><img src="{{d.head_img}}"></div>',
                                width: 80,
                              },
                              { field: "name", title: "姓名" },
                              { field: "ssapid", title: "ssapid" },
                              { field: "description", title: "简介" },
                              ,
                              {
                                field: "experience",
                                title: "研究领域",
                                width: 120,
                              },
                              {
                                field: "is_author",
                                title: "是否是先晓作者",
                                templet: function (res) {
                                  if (res.is_author == 1)
                                  {
                                    return "是";
                                  } else if (res.is_author == 0)
                                  {
                                    return "否";
                                  }
                                },
                              },
                              {
                                field: "status",
                                title: "状态",
                                templet: function (res) {
                                  if (res.status == 1)
                                  {
                                    return "正常";
                                  } else if (res.status == 0)
                                  {
                                    return "禁用";
                                  }
                                },
                              },
                              {
                                title: "操作",
                                width: 200,
                                fixed: "right",
                                toolbar: "#barDemo",
                              },
                            ],
                          ],
                          page: true,
                          // done: function (res, curr, count) {
                          //   console.log(res);
                          //   var that = this.elem.next();
                          //   res.posts.forEach(function (item, index) {
                          //     if (item.is_author == "1") {
                          //       var tr = that.find(
                          //         ".layui-table-box tbody tr[data-index='" +
                          //           index +
                          //           "']"
                          //       );
                          //       tr.find("td").eq(8).find("a").eq(1).hide();
                          //       console.log(tr.find("td").eq(8));
                          //     }
                          //   });
                          // },
                        });
                      } else
                      {
                        console.log(res.msg);
                      }
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                }
              });
            });
          } else if (obj.event === "edit3")
          {
            _this.$router.push({
              name: "NewGuest",
              query: { id: data.id }
            })
          }
        });
      });
    },
    // 公共方法
    handlePublics () {
      let _this = this;
      this.$nextTick(() => {
        layui.use(["jquery", "element", "form", "table"], function () {
          var $ = layui.jquery;
          var element = layui.element;
          var form = layui.form;
          var table = layui.table;

          /*---------报名管理开始---------*/
          /*嘉宾列表查询*/
          let guestTable;
          let url = "/ac1/conference/guest/guestList";
          _this
            .$get(url)
            .then((res) => {
              console.log("嘉宾列表", res);
              if (res.code == "1")
              {
                guestTable = table.render({
                  elem: "#test",
                  data: res.posts.data,
                  response: {
                    statusName: "code", //规定数据状态的字段名称，默认：code
                    statusCode: 1, //规定成功的状态码，默认：0
                    msgName: "hint", //规定状态信息的字段名称，默认：msg
                    countName: "total", //规定数据总数的字段名称，默认：count
                    dataName: "posts", //规定数据列表的字段名称，默认：data
                  },
                  cols: [
                    [
                      { field: "id", title: "ID" },
                      {
                        field: "head_img",
                        title: "嘉宾头像",
                        templet: '<div><img src="{{d.head_img}}"></div>',
                        width: 80,
                      },
                      { field: "name", title: "姓名" },
                      { field: "ssapid", title: "ssapid" },
                      { field: "description", title: "简介" },
                      { field: "domain", title: "研究领域" },
                      {
                        field: "is_author",
                        title: "是否是先晓作者",
                        templet: function (res) {
                          if (res.is_author == 1)
                          {
                            return "是";
                          } else if (res.is_author == 0)
                          {
                            return "否";
                          }
                        },
                      },
                      {
                        field: "status",
                        title: "状态",
                        templet: function (res) {
                          if (res.status == 1)
                          {
                            return "正常";
                          } else if (res.status == 0)
                          {
                            return "禁用";
                          }
                        },
                      },
                      {
                        title: "操作",
                        width: 200,
                        fixed: "right",
                        toolbar: "#barDemo",
                      },
                    ],
                  ],
                  page: true,
                  // done: function (res, curr, count) {
                  //   console.log(res);
                  //   var that = this.elem.next();
                  //   res.posts.forEach(function (item, index) {
                  //     if (item.is_author == "1") {
                  //       var tr = that.find(
                  //         ".layui-table-box tbody tr[data-index='" +
                  //           index +
                  //           "']"
                  //       );
                  //       tr.find("td").eq(8).find("a").eq(1).hide();
                  //       console.log(tr.find("td").eq(8));
                  //     }
                  //   });
                  // },
                });
              } else
              {
                console.log(res.msg);
              }
            })
            .catch((error) => {
              console.log(error);
            });

          /*---------报名管理结束---------*/
          element.render();
          form.render();
          table.render();
        });
      });
    },
  },
  mounted () {
    // 公共方法
    this.handlePublics();
    this.xiang();
  },
  updated () {
    // 公共方法
    this.handlePublics();
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}
/* 设置表格行高 */
.layui-table-cell {
  height: 70px;
  line-height: 70px;
}
.guestManagement .layui-form-label {
  width: auto;
}
.guestManagement .layui-input-block {
  margin-left: 90px;
}
.guestManagement .right_btn {
  margin-top: -10px;
}
</style>
